"use client";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import { useEffect, useState } from "react";
import { LuPhoneCall } from "react-icons/lu";
import { RxEnvelopeClosed } from "react-icons/rx";
// export const metadata = {
//   title: "Guest Rooms || Arena Water Park",
//   description: "Arena Water Park",
// };

// const guestRoomsData = [
//   {
//     id: 1,
//     title: "title",
//     description:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta enim, incidunt corporis velit deserunt facilis in sint adipisci atque illum, ducimus perspiciatis earum tempora assumenda magnam ut quia, ratione eaque. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil numquam magnam, consequatur eius voluptas maxime libero inventore consequuntur. Itaque sequi doloremque earum autem numquam commodi quis cum sit eum ratione!",
//     image: "/assets/img/guestroom-1.jpg",
//     phone: "+91 9876543210",
//     email: "niranjanbudi@gmail.com",
//     bookText: "Book & Stay",
//   },
//   {
//     id: 2,
//     title: "title",
//     description:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta enim, incidunt corporis velit deserunt facilis in sint adipisci atque illum, ducimus perspiciatis earum tempora assumenda magnam ut quia, ratione eaque. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil numquam magnam, consequatur eius voluptas maxime libero inventore consequuntur. Itaque sequi doloremque earum autem numquam commodi quis cum sit eum ratione!",
//     image: "/assets/img/guestroom-2.jpg",
//     phone: "+91 9876543210",
//     email: "niranjanbudi@gmail.com",
//     bookText: "Book & Stay",
//   },
//   {
//     id: 3,
//     title: "title",
//     description:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta enim, incidunt corporis velit deserunt facilis in sint adipisci atque illum, ducimus perspiciatis earum tempora assumenda magnam ut quia, ratione eaque. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil numquam magnam, consequatur eius voluptas maxime libero inventore consequuntur. Itaque sequi doloremque earum autem numquam commodi quis cum sit eum ratione!",
//     image: "/assets/img/guestroom-3.jpg",
//     phone: "+91 9876543210",
//     email: "niranjanbudi@gmail.com",
//     bookText: "Book & Stay",
//   },
//   {
//     id: 4,
//     title: "title",
//     description:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta enim, incidunt corporis velit deserunt facilis in sint adipisci atque illum, ducimus perspiciatis earum tempora assumenda magnam ut quia, ratione eaque. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil numquam magnam, consequatur eius voluptas maxime libero inventore consequuntur. Itaque sequi doloremque earum autem numquam commodi quis cum sit eum ratione!",
//     image: "/assets/img/guestroom-4.jpg",
//     phone: "+91 9876543210",
//     email: "niranjanbudi@gmail.com",
//     bookText: "Book & Stay",
//   },
// ];

export default function GuestRooms() {
  const [GuestRoomsData, setGuestRoomsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuestRooms = async () => {
      try {
        const response = await fetch("/api/guestrooms");
        const data = await response.json();
        setGuestRoomsData(data.guestrooms || []);
      } catch (error) {
        console.error("Failed to fetch guest rooms:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuestRooms();
  }, []);

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: 'url("/assets/img/banners/guestrooms_bg_new.webp")',
        }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  Guest Rooms
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Guest Rooms</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section fix section-padding">
        <div className="container packagefulldetails">
          {loading ? (
            <div className="text-center">
              <h3>Loading Guest Rooms...</h3>
            </div>
          ) : (
            GuestRoomsData.map((item, index) => (
              <div className="row mb-3" key={item._id}>
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        {index % 2 === 0 ? (
                          <>
                            <div className="col-lg-5">
                              <img
                                src={item.image}
                                alt={item.title}
                                style={{
                                  height: "400px",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                                className="faqbg"
                              />
                            </div>
                            <div className="col-lg-7 guestrooms">
                              <h2>{item.title}</h2>
                              <p>{item.description}</p>
                              <div className="contactguestbox">
                                <div className="align-self-center">
                                  <h4 className="bg-bluetxt">For Booking</h4>
                                </div>
                                <div className="d-flex">
                                  <LuPhoneCall />
                                  <h4>{item.mobile}</h4>
                                </div>
                                <div className="d-flex">
                                  <RxEnvelopeClosed />
                                  <h4>{item.email}</h4>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-lg-7 guestrooms order-lg-0 order-1">
                              <h2>{item.title}</h2>
                              <p>{item.description}</p>
                              <div className="contactguestbox">
                                <div className="align-self-center">
                                  <h4 className="bg-bluetxt">For Booking</h4>
                                </div>
                                <div className="d-flex">
                                  <LuPhoneCall />
                                  <h4>{item.mobile}</h4>
                                </div>
                                <div className="d-flex">
                                  <RxEnvelopeClosed />
                                  <h4>{item.email}</h4>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-5 order-lg-1 order-0">
                              <img
                                src={item.image}
                                alt={item.title}
                                width={800}
                                height={600}
                                className="faqbg"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
